import { Grid, Stack, Typography, CardContent, Snackbar, Box, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from "react";
import { StyledCard } from "./ui/Cards";
import { useNavigate } from "react-router-dom";
import ConnectedLogo from "../assets/connected.svg";
import { ConfirmEmail } from "../services/auth.services";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { LoadingBox } from "./ui/Box";

export default function ClientEmailConfirmation() {
	const [snackBarAlert, setSnackBarAlert] = useState(false);
	const [snackBarMessage, setSnackBarMessage] = useState("");
	const [checkConfirmation, setCheckConfirmation] = useState(false);
	const urlParams = new URLSearchParams(window.location.search);
	const code = urlParams.get("code");

	const navigate = useNavigate();

	useEffect(() => {
		const value = {
			code,
		};
		try {
			ConfirmEmail(value.code).then((data) => {
				if (data.ok) {
					setTimeout(() => navigate("/onboarding?emailVerified=true"), 2000);
					setCheckConfirmation(true)
				} else if (data.status === 400) {
					setSnackBarAlert(true);
					setSnackBarMessage("Expired token a renewed token is sent to your email");
				} else if (data.status === 404) {
					setSnackBarAlert(true);
					setSnackBarMessage("Invalid Token");
				} else {
					setSnackBarAlert(true);
					setSnackBarMessage("Somthing went wrong please try again");
				}
			});
		} catch (error) {
			setSnackBarAlert(true);
			setSnackBarMessage("Somthing went wrong please try again");
			console.error('Error', error);;
		}
	}, [code, navigate]);

	if (!checkConfirmation) {
		return (
			<LoadingBox>
				<Stack spacing={2} alignItems="center" sx={{ width: "40%" }} textAlign="center">
					<Typography variant="h1">Verifying Your Email…</Typography>
					<Typography variant="body1_light">Hang tight! We’re confirming your email address. This should only take a moment. Once it's done, you’ll be able to continue with the onboarding process.</Typography>
					<CircularProgress />
				</Stack>
			</LoadingBox>
		);
	}
	return (
		<div className="main">
			<Grid container alignItems="center" justifyContent="center">
				<StyledCard sx={{ width: "50%" }}>
					<CardContent>
						<Grid container alignItems="center" justifyContent="center">
							<Grid item md={12} sx={{ padding: "10%" }} textAlign="center">
								<Typography variant="h1">Email Verified</Typography>
								<br></br>
								<img src={ConnectedLogo} alt="logo" style={{ width: "50%" }} />
								<br></br>
								<br></br>
								<Stack>
									<Typography variant="body1_light">
										Thanks for verifying your email address.
										You can now continue with the onboarding process and start exploring everything we have to offer.
										Let’s get you set up!
									</Typography>
								</Stack>
								<br></br>
							</Grid>
						</Grid>
					</CardContent>
				</StyledCard>
			</Grid>

			<Snackbar
				open={snackBarAlert}
				onClose={() => setSnackBarAlert(false)}
				anchorOrigin={{ vertical: "top", horizontal: "left" }}
				sx={{ top: "0 !important", left: "0 !important" }}
				autoHideDuration={6000}
			>
				<Box
					onClose={() => setSnackBarAlert(false)}
					sx={{ width: "100vw", background: "#F33535", p: 0.5 }}
				>
					<Stack
						direction="row"
						spacing={2}
						sx={{
							width: "100%",
							textAlign: "center",
							alignItems: "center",
							justifyContent: "center",
							color: "#FFFFFF",
						}}
					>
						<CancelOutlinedIcon fontSize="small" />
						<Typography variant="body2">{snackBarMessage}</Typography>
					</Stack>
				</Box>
			</Snackbar>
		</div>
	);
}
